class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    const form = this.querySelector('form');
    if (form) {
      form.addEventListener('input', debounce((event) => {
        this.onSubmitHandler(event);
      }, 300));
    }

    document.querySelectorAll('facet-remove').forEach((element) => {
      element.addEventListener('click', this.onActiveFilterClick);
    });
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    const target = event.target.closest('a');
    if (!target) return;

    fetch(target.href)
      .then(response => response.text())
      .then((content) => {
        this.renderPage(content);
      });
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const formData = new FormData(event.target.closest('form'));
    const params = new URLSearchParams(formData).toString();
    const url = `${window.location.pathname}?${params}`;

    this.renderURL(url);
    this.renderPageFromURL(url);
  }

  renderURL(url) {
    window.history.pushState({}, '', url);
  }

  renderPageFromURL(url) {
    fetch(url)
      .then(response => response.text())
      .then((content) => {
        this.renderPage(content);
      });
  }

  renderPage(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');

    // Actualizar el grid de productos
    const newGrid = parsed.querySelector('#product-grid');
    const oldGrid = document.querySelector('#product-grid');
    if (newGrid && oldGrid) {
      oldGrid.innerHTML = newGrid.innerHTML;
    }

    // Actualizar los filtros
    const newFacets = parsed.querySelector('#FacetsWrapperDesktop');
    const oldFacets = document.querySelector('#FacetsWrapperDesktop');
    if (newFacets && oldFacets) {
      oldFacets.innerHTML = newFacets.innerHTML;
    }

    // Actualizar "active-facets"
    const newActive = parsed.querySelector('.active-facets');
    const oldActive = document.querySelector('.active-facets');
    if (newActive && oldActive) {
      oldActive.innerHTML = newActive.innerHTML;
    }

    // Actualizar contador "Showing X of Y"
    const newCount = parsed.querySelector('.loadcount');
    const oldCount = document.querySelector('.loadcount');
    if (newCount && oldCount) {
      oldCount.innerHTML = newCount.innerHTML;
    }

    this.rebindEvents();
  }

  rebindEvents() {
    const form = document.querySelector('#FacetFiltersForm');
    if (form) {
      form.addEventListener('input', debounce((event) => {
        this.onSubmitHandler(event);
      }, 300));
    }

    document.querySelectorAll('facet-remove').forEach((element) => {
      element.addEventListener('click', this.onActiveFilterClick);
    });
  }
}

customElements.define('facet-filters-form', FacetFiltersForm);

class FacetRemove extends HTMLElement {}
customElements.define('facet-remove', FacetRemove);


// Debounce: evita miles de peticiones al escribir
function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), wait);
  };
}
